import { useSettings } from "@/context/SettingsContext";
import { Seo } from "@/components/site/Seo";

export default function Policies() {
  const { settings } = useSettings();
  const S = ({ id, title, body }) => (
    <section id={id} className="mb-10 scroll-mt-24">
      <h2 className="font-heading text-3xl mb-3">{title}</h2>
      <p className="text-foreground/80 whitespace-pre-line leading-relaxed">{body}</p>
    </section>
  );
  return (
    <div className="pt-24 pb-24">
      <Seo title="Policies" description="Terms & conditions, privacy policy and cancellation / refund policy." />
      <div className="mx-auto max-w-3xl px-6">
        <h1 className="font-heading text-5xl font-semibold mb-10">Policies</h1>
        <S id="terms" title="Terms & Conditions" body={settings.terms} />
        <S id="privacy" title="Privacy Policy" body={settings.privacy} />
        <S id="refund" title="Cancellation / Refund Policy" body={settings.refund_policy} />
      </div>
    </div>
  );
}
